import {
  mapMutations,
  mapState,
} from 'vuex'
import firebase from '@/api/firebase'
export default {
  name: 'Sidebar',
  props: {
    product360: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    drawer: null,
    areas: [],
    tour360Area: {
      label: 'Vídeo 360',
      name: 'Tour 360',
      active: false,
    },
  }),
  computed: {
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      },
    },
  },
  created() {
    this.getAreas()
  },
  methods: {
    getAreas() {
      let params = {
        'orderBy': 'asc'
      }
      firebase.getAreasOrdered(params)
      .then(snapshot => {
        snapshot.forEach(doc => {
          let area = doc.data()
          this.areas.push({
            name: area.name,
            active: false,
          })
        })
      })
    },
    redirect (route) {
      this.$router.push({ name: route })
    },
    setArea(area) {
      if (area.active)
        this.$bus.$emit('search-experience-area', '')
      else
        this.$bus.$emit('search-experience-area', area.name)
    },

    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
  }
}
